import type { ReactNode } from 'react'
import { Command } from 'cmdk'
import { cn } from '../../lib/utils'

export function CommandPaletteItem({
  icon,
  label,
  sublabel,
  onSelect,
  isDark,
}: {
  icon: ReactNode
  label: string
  sublabel?: string
  onSelect: () => void
  isDark: boolean
}) {
  return (
    <Command.Item
      onSelect={onSelect}
      className={cn(
        'group flex cursor-pointer items-center gap-2.5 rounded-lg px-2.5 py-2 text-sm aria-selected:bg-brand-600 aria-selected:text-white',
        isDark ? 'text-neutral-300 hover:bg-surface-3' : 'text-neutral-700 hover:bg-neutral-50',
      )}
    >
      <span className="shrink-0 text-neutral-500 aria-selected:text-white">{icon}</span>
      <div className="flex-1 truncate">
        <span>{label}</span>
        {sublabel && (
          <span className={cn('ml-2 text-xs', isDark ? 'text-neutral-500' : 'text-neutral-400')}>
            {sublabel}
          </span>
        )}
      </div>
    </Command.Item>
  )
}
